import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ObterGlossarioState } from "../reducers/obter-glossario.reducer";

export const selectObterGlossarioState = createFeatureSelector<ObterGlossarioState>('obterGlossario');

export const selectDadosObterGlossario = createSelector(
  selectObterGlossarioState,
  (state: ObterGlossarioState) => state.response
);

export const selectObterGlossario = createSelector(
  selectObterGlossarioState,
  (state: ObterGlossarioState) => state
);

export const selectErrosObterGlossario = createSelector(
  selectObterGlossarioState,
  (state: ObterGlossarioState) => state.error
);